import Swiper, { Autoplay, Navigation } from "swiper";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

document.addEventListener("DOMContentLoaded", function () {
  const sliderElement = document.querySelector(".hero_catalog__wrapper__slider");

  let heroSlider = null;

  if (sliderElement) {
    heroSlider = new Swiper(sliderElement, {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      navigation: {
        nextEl: ".hero_catalog__wrapper__heading__control--next",
        prevEl: ".hero_catalog__wrapper__heading__control--prev",
      },
      breakpoints: {
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
      on: {
        init: initFancybox,
        slideChange: updateFancyboxIfNeeded,
      },
    });

    initFancybox();
  }

  function initFancybox() {
    Fancybox.unbind('[data-fancybox="gallery_hero"]');
    Fancybox.bind('.hero_catalog__wrapper__slider .swiper-slide:not(.swiper-slide-duplicate) [data-fancybox="gallery_hero"]', {
      Toolbar: true,
      closeButton: true,
      dragToClose: true,
      animated: true,
      infinite: true,
    });
  }

  function updateFancyboxIfNeeded() {}

  window.addEventListener("beforeunload", () => {
    Fancybox.destroy();
  });
});